<template>
  <div class="bg-white px-2 md:px-6 p-3 flex items-center">
    <div class="w-full flex items-center">
      <!-- Section gauche -->
      <div class="flex-1 flex items-center">

        <button-element
          v-if="showBackButton"
          :label="'Retour à l\'accueil'"
          :icon="'pi pi-arrow-left'"
          :type="'button'"
          :severity="'blue'"
          :class="$userStore.isProfessional ? 'mt-6' : ''"
          @on-action="goBackToHome"
        />

        <div v-if="$userStore.isProfessional"
          class="font-bold bg-blue text-white p-1 px-[30px] rounded-lg absolute -top-1">
          <div>Espace professionnel</div>
        </div>
      </div>

      <!-- Logo central -->
      <div class="flex-shrink-0 cursor-pointer" @click="router.push({ name: 'home' })">
        <img src="@/assets/img/logo_long.png" alt="selfmat" class="h-[60px]">
      </div>

      <!-- Section droite -->
      <div class="flex-1 flex items-center gap-4 justify-end">

        <!-- Utilisateur connecté -->
        <div v-if="$userStore.loggedUser" class="text-blue font-bold flex items-center relative">
          <div class="flex gap-2 items-center px-3 py-1 border rounded-full pl-6 pr-6">
            <p>Bonjour {{ $userStore.loggedUser.first_name }} {{ $userStore.loggedUser.company?.name }}</p>
          </div>
          <button-element
            :label="''"
            :icon="'pi pi-sign-out'"
            :type="'submit'"
            :severity="'primary'"
            class="!h-[45px] !w-[45px] !rounded-lg -ml-4"
            @on-action="logout"
          />
        </div>

        <!-- Utilisateur non connecté (mode invité) -->
        <div v-else-if="route.name !== 'login' && route.name !== 'login-choice' && route.name !== 'welcome'">
          <div class="flex gap-2 items-center cursor-pointer text-blue font-bold" @click="goToLogin">
            <p>Se connecter</p>
            <button-element
              :label="''"
              :icon="'pi pi-user'"
              :type="'button'"
              :severity="'success'"
              class="!h-[45px] !w-[45px] !rounded-lg"
              @on-action="goToLogin"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import ButtonElement from '@/components/atoms/ButtonElement.vue'
import { computed } from 'vue'
import { useUsers } from '@/features/users/controller'
const $userStore = useUsers()

import { useRoute, useRouter } from 'vue-router'
const route = useRoute()
const router = useRouter()

// Afficher le bouton retour sur certaines pages
const showBackButton = computed(() => {
  return route.name === 'category' ||
         route.name === 'cart' ||
         route.name === 'product'
})

const logout = async () => {
  await $userStore.logout()
}

const goToLogin = () => {
  router.push({ name: 'login-choice' })
}

function goBackToHome() {
  router.push({ name: 'home' })
}
</script>
